import type { Editor } from "./canvas";
const endpointSnapping = new WeakMap<Editor, boolean>();
export const snapEndpoints = (editor: Editor) =>
  endpointSnapping.get(editor) ?? true;
export const setSnapEndpoints = (editor: Editor, value: boolean) =>
  endpointSnapping.set(editor, value);
